'use client';

import { CardCodeField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-code.js';
import { CardExpiryField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-expiry.js';
import { CreditCardFields } from '@sola/ark-core/molecules/credit-card-fields/credit-card-fields.js';
import { CardNameField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-name.js';
import { CardNumberField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-number.js';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.js';

export const PaymentCCFields = () => {
  return (
    <CreditCardFields>
      <CardNumberField
        name="cardNumber"
        label="Card number"
        iconName="credit-card-02"
        iconClasses="CardInput"
        required
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
      />

      <CardNameField
        name="nameOnCard"
        label="Name on card"
        required
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
      />

      <div className="flex flex-row space-between gap-comfy-sm">
        <CardExpiryField
          name="expirationDate"
          label="Expiration date"
          fieldClasses="InputExp"
          required
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
        />

        <CardCodeField
          name="cvv"
          label="CVV"
          iconClasses="InfoInput"
          iconName="info-circle"
          fieldClasses="InputExp"
          required
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
        />
      </div>
      <InputField
        name="cardNickname"
        label="Nickname for this card"
        hint="(optional)"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
      />
    </CreditCardFields>
  );
};
